import { API_BASE_URL } from "../../config";

export const apiFetch = async (endpoint: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: options.method || "GET",
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
      ...options,
    });

    let data: any = {};

    try {
      data = await response.json();
    } catch (e) {
      data = { message: "No response body" };
    }

    return {
      status: response.status,
      ok: response.ok,
      data,
    };
  } catch (error: any) {
    console.error("API Error:", error);

    return {
      status: 0,
      ok: false,
      data: {
        message: error.message || "Unknown error",
      },
    };
  }
};
